import { Colorway, cssTheme } from '@uds/theme-utils';
import { css, cx } from 'linaria';

const domainName = css`
  &[data-alignment='CENTER'] {
    text-align: center;
  }
`;

const root = css`
  color: ${cssTheme.palette.primary};
  text-decoration: none;
  a&:hover .${domainName} {
    opacity: 0.75;
  }
  &:hover {
    text-decoration: none;
  }
`;

const card = {
  default: css`
    height: calc(100% - ${cssTheme.gu2});
    background: #fff;
  `,
  light: css`
    background: ${cssTheme.palette.grey12};
  `,
};

export default ({ colorway }: { colorway: Colorway }) => {
  return {
    root,
    card: cx(card.default, colorway === Colorway.LIGHT && card.light),
    domainName,
  };
};
